/*
 * Copyright (c) 2018 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/index';
import { ComponentModel } from '@typescript-kit/view';
import { ChangedEvent } from '@typescript-kit/core';

@Directive({
  selector: '[kitVisible]'
})
export class VisibleDirective implements OnDestroy {

  private readonly element: HTMLElement;
  private originalDisplayStyle: string;

  private _model: ComponentModel;
  private _modelChangedSubscription: Subscription;

  constructor(element: ElementRef) {
    this.element = element.nativeElement;
    this.originalDisplayStyle = null;
  }

  ngOnDestroy(): void {
    if (this._modelChangedSubscription) {
      this._modelChangedSubscription.unsubscribe();
      this._modelChangedSubscription = null;
    }
  }

  @Input('kitVisible')
  set model(model: ComponentModel) {
    if (this._model === model) {
      return;
    }
    if (this._modelChangedSubscription) {
      this._modelChangedSubscription.unsubscribe();
    }
    this._model = model;
    if (model) {
      this._modelChangedSubscription = model.changedEvent
        .subscribe((changedEvent: ChangedEvent) => {
          if (!changedEvent.changes['isHidden']) {
            return;
          }
          this.refresh();
        });
    } else {
      this._modelChangedSubscription = null;
    }
    this.refresh();
  }

  get model(): ComponentModel {
    return this._model;
  }

  private refresh() {
    if (this.model && this.model.isHidden) {
      this.originalDisplayStyle = this.element.style.display;
      this.element.style.display = 'none';
    } else if (this.originalDisplayStyle !== null) {
      this.element.style.display = this.originalDisplayStyle;
      this.originalDisplayStyle = null;
    }
  }

}
